import { of } from "rxjs";
import { Observable } from 'rxjs';
export class DataProvider {
    constructor() {
        this.title = '';
        this.id = '';
        this.system = '';
        this.tenantId = null;
        this.getData = () => { return of(new PagedData()) }
    }
    public title: string; //Text which can be shown to the end user. E.g. “ESP Process”, “EngPro Project” etc.
    public system: string; //Unique identifier for the system. E.g. “esp.exceeders.com”
    public tenantId: string; //Tenant (organization) Id 
    public id: string;//In case a system has multiple providers, this property can be set to distinguish between them.
    public getData?: (nextPageToken?: any, isAll?: any) => Observable<PagedData>
}

export class PagedData {

    public nextPageToken?: any //An object that can be passed to get the next page, or null if there is no more data available.;
    public items: PagedDataItem[] = []

    constructor() {
        this.items = [];
        this.nextPageToken = null;
    }

}

export class PagedDataItem {
    constructor() {
        this.title = '';
        this.id = '';
        this.keyword = '';
        this.url = '';
        this.extraData = null;
        this.permission = '';
        this.getData = () => { return of(new PagedData()) }
        this.isSimpleProject = false;

    }
    public title: string;//User readable title of the object
    public id: string; //Unique Id of the data
    public keyword?: string; //Optional keyword to help searching items.
    public url?: string; // Url to see details of the Item.
    public extraData?: any; // Optionally a  dictionary containing extra data.
    public getData?: (nextPageToken?: any) => Observable<PagedData>// method to get next level data 
    public permission?: string;
    public isSimpleProject?: boolean;

}
